import { StateCreator } from "zustand";

export interface ToastSlice {
  toastMessage: string | null;
  showToast: (message: string) => void;
  hideToast: () => void;
}

export const createToastSlice: StateCreator<ToastSlice> = set => ({
  toastMessage: null,
  showToast: toastMessage => set({ toastMessage }),
  hideToast: () => set({ toastMessage: null }),
});
